export const switchFieldWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '100%',
};

export const switchFieldRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const switchFieldErrorStyles = {
  color: 'error.main',
};

export const labelWithTooltipStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
};
